module.exports = "/assets/kinley-page/beverage_3@2x.png?GRHRk2Y";